import React, { useEffect } from 'react';
import MinningBanner from './MinningBanner';

import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Industrypatners from './Industrypatners';
import Mininanimatedcards from './Mininanimatedcards';
import Mininverticaltabs from './Mininverticaltabs';
import Healthcareverticalcards from './Healthcareverticalcards';
const MiningPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <MinningBanner />
      <Automotivemobilitecards />
      <AutomobilityTabs />
      <Mininverticaltabs />
     {/* <Healthcareverticalcards /> */}
      {/* <Automobilityverticaltabs /> */}
      <AerospaceIntroductioncards />
      <Mininanimatedcards />
      <AerospaceInsightsCards />

      <Industrypatners />


      <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style>
    </div>
  )
}

export default MiningPage;